/**
 * The Periodicity of the query. It may depend on the level of granularity you write the range params.
 *
 * @public
 */
export var Periodicity;
(function (Periodicity) {
    /**
     * Example: after:25/01/1983, before:04/03/2013, after:$d-30, before:$d, after:$d-15/$m
     */
    Periodicity["DAILY"] = "DAILY";
    /**
     * Example: after:jan/2013, before:mar/2013, after:$m-1, before:$m
     */
    Periodicity["MONTHLY"] = "MONTHLY";
    /**
     * Example: on:2013, after:2013, $y
     */
    Periodicity["YEARLY"] = "YEARLY";
})(Periodicity || (Periodicity = {}));
/**
 * Decimal separator of numbers on book
 *
 * @public
 */
export var DecimalSeparator;
(function (DecimalSeparator) {
    /**
     * ,
     */
    DecimalSeparator["COMMA"] = "COMMA";
    /**
     * .
     */
    DecimalSeparator["DOT"] = "DOT";
})(DecimalSeparator || (DecimalSeparator = {}));
/**
 * Enum representing permissions of user in the Book
 *
 * @public
 */
export var Permission;
(function (Permission) {
    /**
     * No permission
     */
    Permission["NONE"] = "NONE";
    /**
     * View transactions, accounts and balances.
     */
    Permission["VIEWER"] = "VIEWER";
    /**
     * Record and delete drafts only. Useful to collect data only
     */
    Permission["RECORDER"] = "RECORDER";
    /**
     * View transactions, accounts, record and delete drafts
     */
    Permission["POSTER"] = "POSTER";
    /**
     * Manage accounts, transactions, book configuration and sharing
     */
    Permission["EDITOR"] = "EDITOR";
    /**
     * Manage everything, including book visibility and deletion. Only one owner per book.
     */
    Permission["OWNER"] = "OWNER";
})(Permission || (Permission = {}));
/**
 * Enum representing the visibility of a Book
 *
 * @public
 */
export var Visibility;
(function (Visibility) {
    /**
     * The book can be accessed by anyone with the link
     */
    Visibility["PUBLIC"] = "PUBLIC";
    /**
     * The book can be accessed by the owner and collaborators
     */
    Visibility["PRIVATE"] = "PRIVATE";
})(Visibility || (Visibility = {}));
/**
 * Enum that represents account types.
 *
 * @public
 */
export var AccountType;
(function (AccountType) {
    /**
     * Asset account type
     */
    AccountType["ASSET"] = "ASSET";
    /**
     * Liability account type
     */
    AccountType["LIABILITY"] = "LIABILITY";
    /**
     * Incoming account type
     */
    AccountType["INCOMING"] = "INCOMING";
    /**
     * Outgoing account type
     */
    AccountType["OUTGOING"] = "OUTGOING";
})(AccountType || (AccountType = {}));
/**
 * Enum that represents balance types.
 *
 * @public
 */
export var BalanceType;
(function (BalanceType) {
    /**
     * Total balance
     */
    BalanceType["TOTAL"] = "TOTAL";
    /**
     * Period balance
     */
    BalanceType["PERIOD"] = "PERIOD";
    /**
     * Cumulative balance
     */
    BalanceType["CUMULATIVE"] = "CUMULATIVE";
})(BalanceType || (BalanceType = {}));
/**
 * Enum that represents a period slice.
 *
 * @public
 */
export var Period;
(function (Period) {
    /**
     *  Monthly period
     */
    Period["MONTH"] = "MONTH";
    /**
     * Quarterly period
     */
    Period["QUARTER"] = "QUARTER";
    /**
     * Yearly period
     */
    Period["YEAR"] = "YEAR";
})(Period || (Period = {}));
/**
 * Enum that represents a Month.
 *
 * @public
 */
export var Month;
(function (Month) {
    Month["JANUARY"] = "JANUARY";
    Month["FEBRUARY"] = "FEBRUARY";
    Month["MARCH"] = "MARCH";
    Month["APRIL"] = "APRIL";
    Month["MAY"] = "MAY";
    Month["JUNE"] = "JUNE";
    Month["JULY"] = "JULY";
    Month["AUGUST"] = "AUGUST";
    Month["SEPTEMBER"] = "SEPTEMBER";
    Month["OCTOBER"] = "OCTOBER";
    Month["NOVEMBER"] = "NOVEMBER";
    Month["DECEMBER"] = "DECEMBER";
})(Month || (Month = {}));
/**
 * Enum that represents the status of a Transaction.
 *
 * @public
 */
export var TransactionStatus;
(function (TransactionStatus) {
    /**
     * Transaction is in the trash
     */
    TransactionStatus["TRASHED"] = "TRASHED";
    /**
     * Transaction is a draft, not yet posted
     */
    TransactionStatus["DRAFT"] = "DRAFT";
    /**
     * Transaction is posted but not checked
     */
    TransactionStatus["UNCHECKED"] = "UNCHECKED";
    /**
     * Transaction is posted and checked
     */
    TransactionStatus["CHECKED"] = "CHECKED";
})(TransactionStatus || (TransactionStatus = {}));
/**
 * Enum that represents how an App menu opens.
 *
 * @public
 */
export var MenuOpenMode;
(function (MenuOpenMode) {
    /**
     * Open inside the sidebar panel.
     */
    MenuOpenMode["SIDEBAR"] = "SIDEBAR";
    /**
     * Open expanded inside the app panel.
     */
    MenuOpenMode["EXPANDED"] = "EXPANDED";
    /**
     * Open in a new browser tab.
     */
    MenuOpenMode["NEW_TAB"] = "NEW_TAB";
})(MenuOpenMode || (MenuOpenMode = {}));
/**
 * Enum that represents the type of a Bot Response
 *
 * @public
 */
export var BotResponseType;
(function (BotResponseType) {
    /**
     * Info bot response
     */
    BotResponseType["INFO"] = "INFO";
    /**
     * Warning bot response
     */
    BotResponseType["WARNING"] = "WARNING";
    /**
     * Error bot response
     */
    BotResponseType["ERROR"] = "ERROR";
})(BotResponseType || (BotResponseType = {}));
/**
 * Enum that represents event types.
 *
 * @public
 */
export var EventType;
(function (EventType) {
    EventType["FILE_CREATED"] = "FILE_CREATED";
    EventType["FILE_UPDATED"] = "FILE_UPDATED";
    EventType["FILE_DELETED"] = "FILE_DELETED";
    EventType["TRANSACTION_CREATED"] = "TRANSACTION_CREATED";
    EventType["TRANSACTION_UPDATED"] = "TRANSACTION_UPDATED";
    EventType["TRANSACTION_DELETED"] = "TRANSACTION_DELETED";
    EventType["TRANSACTION_POSTED"] = "TRANSACTION_POSTED";
    EventType["TRANSACTION_CHECKED"] = "TRANSACTION_CHECKED";
    EventType["TRANSACTION_UNCHECKED"] = "TRANSACTION_UNCHECKED";
    EventType["TRANSACTION_RESTORED"] = "TRANSACTION_RESTORED";
    EventType["ACCOUNT_CREATED"] = "ACCOUNT_CREATED";
    EventType["ACCOUNT_UPDATED"] = "ACCOUNT_UPDATED";
    EventType["ACCOUNT_DELETED"] = "ACCOUNT_DELETED";
    EventType["QUERY_CREATED"] = "QUERY_CREATED";
    EventType["QUERY_UPDATED"] = "QUERY_UPDATED";
    EventType["QUERY_DELETED"] = "QUERY_DELETED";
    EventType["GROUP_CREATED"] = "GROUP_CREATED";
    EventType["GROUP_UPDATED"] = "GROUP_UPDATED";
    EventType["GROUP_DELETED"] = "GROUP_DELETED";
    EventType["COMMENT_CREATED"] = "COMMENT_CREATED";
    EventType["COMMENT_DELETED"] = "COMMENT_DELETED";
    EventType["COLLABORATOR_ADDED"] = "COLLABORATOR_ADDED";
    EventType["COLLABORATOR_UPDATED"] = "COLLABORATOR_UPDATED";
    EventType["COLLABORATOR_REMOVED"] = "COLLABORATOR_REMOVED";
    EventType["INTEGRATION_CREATED"] = "INTEGRATION_CREATED";
    EventType["INTEGRATION_UPDATED"] = "INTEGRATION_UPDATED";
    EventType["INTEGRATION_DELETED"] = "INTEGRATION_DELETED";
    EventType["BOOK_AUDITED"] = "BOOK_AUDITED";
    /**
     * Daily per-Book event for Apps subscribed to it, delivered at or after 01:00 in the Book's time zone.
     */
    EventType["BOOK_OVERNIGHT"] = "BOOK_OVERNIGHT";
    EventType["BOOK_CREATED"] = "BOOK_CREATED";
    EventType["BOOK_UPDATED"] = "BOOK_UPDATED";
    EventType["BOOK_DELETED"] = "BOOK_DELETED";
})(EventType || (EventType = {}));
//# sourceMappingURL=Enums.js.map